import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';

import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

declare var getHexAscii: any;

@Component({
  selector: 'app-branch-to-branch-transfer',
  templateUrl: './branch-to-branch-transfer.component.html',
  styleUrls: ['./branch-to-branch-transfer.component.css']
})
export class BranchToBranchTransferComponent implements OnInit {
  isShow:string;
  isLoad: boolean;
  scoAccounts: any = [];
  payeeList: any = [];
  nickNameScb: any = '';
  toAccountNoScb: any;
  fromAccountNoScb: any = '';
  amountScb: string;
  narrationScb: any;
  isShowScb: string = 'page1';
  otpScb: any;
  accountNo: any;
  userName: string;
  accountNoLoan: any;
  accountInfo: any;
  transactionList: any;
  isTrueLoan: string;
  accountInfoLoan: any;
  loanAccounts: any = [];
  error: string = '';

  regSpeci = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  //regNum = /^.*[0-9]/;
  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum = /^[0-9]+$/;
  regexcap = /^.*?[A-Z]/;
  curRegExp = /^(?:0|[1-9]\d*)(?:\.(?!.*000)\d+)?$/;

  fromAccountNoScbtoBank: string;
  disabled: boolean;
  ickValidateNameBank: string;
  nickValidateNameBank: string;
  amountNotlankBank: string;
  amountmessageForSpaceBank: string;
  amountZeroOnlyBank: string;
  notValidAmmountBank: string;
  narrationValidateBank: string;
  OtpNotlankbank: string;
  greterThanZero: string;
  disableSubBtn:boolean=false;
  disableNextBtn:boolean=false;

  constructor(private webService: CallBackEndService,

    private spinnerService: Ng4LoadingSpinnerService
 ) {
    this.userName =sessionStorage.getItem('storedUserName');
    this.scoAccounts = JSON.parse(sessionStorage.getItem('scoAccounts'));
    this.loanAccounts = JSON.parse(sessionStorage.getItem('loanAccounts'));
    const request: IbRequest = new IbRequest();
    let response: IbResponse = null;
    this.isLoad = true;
    request.param1 = getHexAscii('', this.userName + 'scbToscb');
    request.param2 = this.userName;
    request.param3 = 'scbToscb';
    this.webService.getResponse(request, 'getAllPayee').subscribe((data: IbResponse) => {
      response = data;
      this.isLoad = false;
      if (response !== null && response.status === 'S200')  {
        this.payeeList = response.param6;
      } else if (response !== null) {
        this.error = response.param1;
      } else {
        this.error = 'Something Went Wrong Please Contact Customer Care';
      }
    });
  }

  ngOnInit() {
   
  }

  getToAccountNoScb() {
    this.error = '';
    for (let i = 0; i < this.payeeList.length; i++) {
      if (this.payeeList[i].nickname === this.nickNameScb) {
        this.toAccountNoScb = this.payeeList[i].acctno;
      }
    }
  }

  getOtpScbToScb() {
  
    this.error = '';
    this.allValidation();
    if (this.fromAccountNoScb && this.toAccountNoScb && this.amountScb && this.narrationScb && this.disabled === false) {
        this.spinnerService.show();
      this.disableNextBtn=true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.userName);
      request.param2 = this.userName;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200')  {
          // console.log('Otp :' + response.param1);
          this.isShowScb = 'page2';
          this.spinnerService.hide();
        } else if (response !== null) {
          this.error = response.param1;
          this.disableNextBtn=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.disableNextBtn=false;
        }
      });
    }
  }

  sTsFundTransferRequest() {
   
    this.error = '';
    if (this.fromAccountNoScb && this.toAccountNoScb && this.amountScb && this.narrationScb && this.otpScb && this.disabled === false 
      && this.getBankOTPValid()) {
        this.spinnerService.show();
      this.isLoad = true;
      const otpScbDetails: any = {
        'userName': this.userName,
        'otp': getHexAscii('',this.otpScb)
      };
      this.disableSubBtn=true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.fromAccountNoScb + this.toAccountNoScb + this.amountScb + this.narrationScb + this.userName + this.otpScb);
      request.param2 = this.fromAccountNoScb;
      request.param3 = this.toAccountNoScb;
      request.param4 = this.amountScb;
      request.param5 = this.narrationScb;
      request.param6 = otpScbDetails;
      this.webService.getResponse(request, 'compToCompAndScbToScbFundTransfer').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200')  {
          this.accountNo = this.fromAccountNoScb;
          //this.showTransaction();
          for (let i = 0; i < this.loanAccounts.length; i++) {
            if (this.loanAccounts[i] === this.toAccountNoScb) {
              this.accountNoLoan = this.toAccountNoScb;
              //this.showTransactionLoan();
            }
            this.disableSubBtn=false;
          }
        
           this.isShowScb='page3';
         this.error = 'Your transaction is completed successfully for Rs.'+this.amountScb+' to Account Number '+this.toAccountNoScb+' With Reference No :' + response.param2;
       
        }else if (response != null && (response.status==='S333' || response.status==='S334') ) {
          this.error= response.param1;
        } 
        else if (response !== null) {
         
          if(response.param1==null  || response.param1==undefined){
            this.error ='Something Went Wrong';
          }else{
            this.error ='Your transaction is declined for Rs.'+this.amountScb+' due to '+ response.param1;
          }
          
          this.disableSubBtn=false;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
          this.disableSubBtn=false;
        }
      });
    }
  }


  back() {
    this.error = '';
    this.otpScb = '';
    this.OtpNotlankbank='';
    this.isShowScb = 'page1';
    this.disableNextBtn=false;
  }
 

  showTransaction() {
    this.error = '';
    if (this.accountNo && this.accountNo !== '') {
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.accountNo);
      request.param2 = this.accountNo;
      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200')  {
          this.accountInfo = response.param5;
          this.transactionList = response.param8;
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  showTransactionLoan() {
    this.error = '';
    if (this.accountNoLoan && this.accountNoLoan !== '') {
      this.isTrueLoan = 'hide';
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.accountNoLoan);
      request.param2 = this.accountNoLoan;
      this.webService.getResponse(request, 'miniTransactionList').subscribe((data: IbResponse) => {
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'S200')  {
          this.accountInfoLoan = response.param5;
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  allValidation() {
    this.fromAcctValidate();
    if (!this.disabled) {
      this.nickNameValidate();
      if (!this.disabled) {
        this.nickNameValidate();
      }if (!this.disabled) {
          this.getAmountValidbanktobank();
        }if (!this.disabled) {
          this.messagesNarrationBank();
        }
      }
    }

  fromAcctValidate() {
    if (this.fromAccountNoScb === undefined || this.fromAccountNoScb === '') {
      this.fromAccountNoScbtoBank = 'no';
      this.disabled = true;
    }
  }
  removeMessageFromAcct() {
    this.fromAccountNoScbtoBank = '';
    this.disabled = false;
  }
  nickNameValidate() {
    if (this.nickNameScb === undefined || this.nickNameScb === '') {
      this.nickValidateNameBank = 'no';
      this.disabled = true;
    }
  }
  removeMessagetoAcct() {
    this.nickValidateNameBank = '';
    this.disabled = false;
  }
  getAmountValidbanktobank() {
    if (this.amountScb === undefined || this.amountScb === '') {
      this.amountNotlankBank = 'no';
      this.disabled = true;
    } else if (this.amountScb.match(this.regexpspace)) {
      this.amountmessageForSpaceBank = 'no';
      this.disabled = true;
    } else if (this.amountScb.match(this.regZeroOnly)) {
      this.amountZeroOnlyBank = 'no';
      this.disabled = true;
    } else if (!this.amountScb.match(this.curRegExp)) {
      this.notValidAmmountBank = 'no';
      this.disabled = true;
    } else if ( parseFloat(this.amountScb) <= 0) {
      this.greterThanZero = 'no';
      this.disabled = true;
    }

  }

  removeMessagesbanktobank() {
    this.amountNotlankBank = '';
    this.amountmessageForSpaceBank = '';
    this.amountZeroOnlyBank = '';
    this.notValidAmmountBank = '';
    this.greterThanZero = '';
    this.disabled = false;
  }

  messagesNarrationBank() {
    if (this.narrationScb === undefined || this.narrationScb === '') {
      this.narrationValidateBank = 'no';
      this.disabled = true;
    }
  }
  removeMessageNarrationBank() {
    this.narrationValidateBank = '';
    this.disabled = false;
  }
  getBankOTPValid() {
    if (this.otpScb === undefined || this.otpScb === '') {
      this.OtpNotlankbank = 'no';
      return false;
    }else if (this.otpScb.match(this.reg)) {
      this.OtpNotlankbank = 'specialChar';
      return false;
    }else if (!this.otpScb.match(this.regNum)) {
      this.OtpNotlankbank = 'num';
      return false;
    } else if (this.otpScb.length!=6) {
      this.OtpNotlankbank = 'len';
      return false;
    }else{
      this.OtpNotlankbank = '';
      return true;
    }
  }
  getBankOTPValidOld() {
     this.error="";
    if (this.otpScb === undefined || this.otpScb === '') {
      this.OtpNotlankbank = 'no';
      this.disabled = true;
    }
  }

  getBankmesageOTPRemove() {
    this.OtpNotlankbank = '';
    this.error="";
    this.disabled = false;
    this.disableSubBtn=false;
  }
}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/branch-to-branch-transfer/branch-to-branch-transfer.component.ts